import React from "react";
import { useLang } from "@/context/LanguageContext";

// Premium Panchangam labels with built-in Hindi / Tamil / Telugu text, so they
// read in the reader's language as soon as the code ships. An admin-published
// translation (the same store <T> reads) always wins; English is the last resort.
export const PREMIUM_LABELS = {
  // Dasha lord meanings (AdvancedDasha MEANING)
  "Detachment, spiritual turns, letting go.": { hi: "वैराग्य, आध्यात्मिक मोड़, त्याग।", ta: "பற்றின்மை, ஆன்மீகத் திருப்பங்கள், விட்டுக்கொடுத்தல்.", te: "వైరాగ్యం, ఆధ్యాత్మిక మలుపులు, వదులుకోవడం." },
  "Relationships, comfort, creativity, prosperity.": { hi: "संबंध, सुख-सुविधा, सृजनशीलता, समृद्धि।", ta: "உறவுகள், சுகம், படைப்பாற்றல், செழிப்பு.", te: "సంబంధాలు, సుఖం, సృజనాత్మకత, సమృద్ధి." },
  "Authority, recognition, father, vitality.": { hi: "अधिकार, मान-सम्मान, पिता, ओज।", ta: "அதிகாரம், அங்கீகாரம், தந்தை, உயிர்ச்சக்தி.", te: "అధికారం, గుర్తింపు, తండ్రి, తేజస్సు." },
  "Mind, emotions, home, nurturing.": { hi: "मन, भावनाएँ, घर, पालन-पोषण।", ta: "மனம், உணர்ச்சிகள், வீடு, பேணுதல்.", te: "మనస్సు, భావోద్వేగాలు, ఇల్లు, పోషణ." },
  "Drive, courage, property, conflict.": { hi: "उत्साह, साहस, संपत्ति, संघर्ष।", ta: "உந்துதல், தைரியம், சொத்து, மோதல்.", te: "ఉత్సాహం, ధైర్యం, ఆస్తి, సంఘర్షణ." },
  "Ambition, change, foreign, sudden rise.": { hi: "महत्वाकांक्षा, परिवर्तन, विदेश, अचानक उन्नति।", ta: "லட்சியம், மாற்றம், வெளிநாடு, திடீர் உயர்வு.", te: "ఆకాంక్ష, మార్పు, విదేశం, ఆకస్మిక ఉన్నతి." },
  "Wisdom, growth, teachers, fortune.": { hi: "ज्ञान, विकास, गुरु, सौभाग्य।", ta: "ஞானம், வளர்ச்சி, ஆசிரியர்கள், அதிர்ஷ்டம்.", te: "జ్ఞానం, వృద్ధి, గురువులు, అదృష్టం." },
  "Discipline, delay, hard-won results, karma.": { hi: "अनुशासन, विलंब, परिश्रम से मिले फल, कर्म।", ta: "ஒழுக்கம், தாமதம், கடின உழைப்பின் பலன்கள், கர்மா.", te: "క్రమశిక్షణ, ఆలస్యం, కష్టపడి సాధించిన ఫలితాలు, కర్మ." },
  "Intellect, commerce, communication, learning.": { hi: "बुद्धि, व्यापार, संवाद, अध्ययन।", ta: "அறிவாற்றல், வணிகம், தொடர்பாடல், கற்றல்.", te: "బుద్ధి, వాణిజ్యం, సంభాషణ, అభ్యాసం." },
  "Vimshottari Dasha": { hi: "विंशोत्तरी दशा", ta: "விம்சோத்தரி தசை", te: "వింశోత్తరి దశ" },
  "Running planetary periods — tap a period to drill in": { hi: "चल रही ग्रह दशाएँ — विवरण के लिए किसी अवधि पर टैप करें", ta: "நடப்பு கிரக தசைகள் — விவரங்களுக்கு ஒரு காலத்தைத் தட்டவும்", te: "ప్రస్తుత గ్రహ దశలు — వివరాల కోసం ఒక కాలాన్ని నొక్కండి" },
  "Running now": { hi: "अभी चल रहा", ta: "தற்போது நடப்பில்", te: "ప్రస్తుతం నడుస్తోంది" },
  "120-year timeline": { hi: "120 वर्ष की समयरेखा", ta: "120 ஆண்டு காலவரிசை", te: "120 సంవత్సరాల కాలక్రమం" },
  "Mahadasha periods": { hi: "महादशा अवधियाँ", ta: "மகாதசை காலங்கள்", te: "మహాదశ కాలాలు" },
  "View full timeline": { hi: "पूरी समयरेखा देखें", ta: "முழு காலவரிசையைக் காண்க", te: "పూర్తి కాలక్రమం చూడండి" },
  "Show less": { hi: "कम दिखाएँ", ta: "குறைவாகக் காட்டு", te: "తక్కువ చూపించు" },
  "Read more": { hi: "और पढ़ें", ta: "மேலும் படிக்க", te: "మరింత చదవండి" },
  "Mahadasha": { hi: "महादशा", ta: "மகாதசை", te: "మహాదశ" },
  "Antardasha": { hi: "अंतर्दशा", ta: "அந்தர்தசை", te: "అంతర్దశ" },
  "Antardashas": { hi: "अंतर्दशाएँ", ta: "அந்தர்தசைகள்", te: "అంతర్దశలు" },
  "Pratyantar": { hi: "प्रत्यंतर", ta: "பிரத்யந்தர", te: "ప్రత్యంతర" },
  "Antar": { hi: "अंतर", ta: "அந்தர", te: "అంతర" },
  "now": { hi: "अभी", ta: "இப்போது", te: "ఇప్పుడు" },
  "No antardasha data for this period.": { hi: "इस अवधि के लिए अंतर्दशा विवरण उपलब्ध नहीं।", ta: "இந்தக் காலத்திற்கு அந்தர்தசை விவரம் இல்லை.", te: "ఈ కాలానికి అంతర్దశ వివరాలు లేవు." },
  "Sun below horizon": { hi: "सूर्य क्षितिज के नीचे", ta: "சூரியன் அடிவானத்திற்குக் கீழே", te: "సూర్యుడు క్షితిజం కింద" },
  "Above horizon": { hi: "क्षितिज के ऊपर", ta: "அடிவானத்திற்கு மேலே", te: "క్షితిజం పైన" },
  "Below horizon": { hi: "क्षितिज के नीचे", ta: "அடிவானத்திற்குக் கீழே", te: "క్షితిజం కింద" },
  "Auspicious": { hi: "शुभ", ta: "சுபம்", te: "శుభం" },
  "Inauspicious": { hi: "अशुभ", ta: "அசுபம்", te: "అశుభం" },
  "Mixed": { hi: "मिश्रित", ta: "கலப்பு", te: "మిశ్రమం" },
};

// Moon-card phase line ("in <nakshatra> · <phase> · NN% lit") in the reader's language.
const MOON_PHASES = {
  "New Moon · Amāvāsyā": { hi: "अमावस्या", ta: "அமாவாசை", te: "అమావాస్య" },
  "Full Moon · Pūrṇimā": { hi: "पूर्णिमा", ta: "பௌர்ணமி", te: "పౌర్ణమి" },
  "Waxing Crescent": { hi: "बढ़ता चंद्र (अर्धचंद्राकार)", ta: "வளர்பிறை பிறை", te: "వృద్ధి చెందుతున్న నెలవంక" },
  "Waxing Gibbous": { hi: "बढ़ता चंद्र", ta: "வளர்பிறை", te: "వృద్ధి చెందుతున్న చంద్రుడు" },
  "First Quarter": { hi: "प्रथम चतुर्थांश", ta: "முதல் கால் பகுதி", te: "మొదటి పాదం" },
  "Waning Gibbous": { hi: "घटता चंद्र", ta: "தேய்பிறை", te: "క్షీణిస్తున్న చంద్రుడు" },
  "Waning Crescent": { hi: "घटता चंद्र (अर्धचंद्राकार)", ta: "தேய்பிறை பிறை", te: "క్షీణిస్తున్న నెలవంక" },
  "Last Quarter": { hi: "अंतिम चतुर्थांश", ta: "கடைசி கால் பகுதி", te: "చివరి పాదం" },
};
export function moonInNakshatra(nak, lang) {
  if (lang === "hi") return `${nak} नक्षत्र में`;
  if (lang === "ta") return `${nak} நட்சத்திரத்தில்`;
  if (lang === "te") return `${nak} నక్షత్రంలో`;
  return `in ${nak}`;
}
export function moonPhaseLine(name, illum, lang) {
  const n = (MOON_PHASES[name] && MOON_PHASES[name][lang]) || name;
  if (lang === "hi") return `${n} · ${illum}% प्रकाशित`;
  if (lang === "ta") return `${n} · ${illum}% ஒளிர்வு`;
  if (lang === "te") return `${n} · ${illum}% ప్రకాశం`;
  return `${n} · ${illum}% lit`;
}

export function PL({ children }) {
  const { tx, lang } = useLang();
  const raw = typeof children === "string" ? children : Array.isArray(children) ? children.filter((c) => typeof c === "string").join("") : "";
  if (!raw || lang === "en") return <>{raw}</>;
  const r = tx(raw);
  if (!r.pending) return <>{r.text}</>;
  const built = PREMIUM_LABELS[raw.trim()]?.[lang];
  return <>{built || raw}</>;
}

export default PL;
